import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=06ed193f&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ed193f')) {
      api.createRecord('06ed193f', component.options)
    } else {
      api.reload('06ed193f', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=06ed193f&", function () {
      api.rerender('06ed193f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23LixZY8t6TPM/JS/pricehelp.vue"
export default component.exports